export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-5 animate-fade-in">
              <i className="ri-fire-line text-sm"></i>
              今日更新 86 部
            </span>

            {/* H1 */}
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3 animate-slide-up">
              黄瓜影院
              <span className="block text-primary-600 md:inline md:ml-2 text-lg md:text-4xl lg:text-5xl">
                · 免费高清影视在线观看
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-sm md:text-base text-foreground-500 font-medium mb-5 animate-slide-up">
              海量片库 · 即点即播 · 智能追剧
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 animate-slide-up">
              黄瓜影院汇聚全网<strong>最新电视剧全集</strong>与<strong>电影大全</strong>，提供<strong>高清画质</strong>在线观看体验，无需缓冲流畅播放。无论您偏爱热播国产剧、经典韩剧、口碑美剧还是院线大片，这里都能<strong>快速找片</strong>，<strong>智能推荐</strong>帮您发现下一部心头好。每日更新<strong>最新剧集完整版</strong>，追剧不等待。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7 animate-slide-up">
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-600">12万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-accent-600">80+</div>
                <div className="text-xs text-foreground-500 mt-0.5">每日更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-600">1080P</div>
                <div className="text-xs text-foreground-500 mt-0.5">高清画质</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-slide-up">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer shadow-lg shadow-primary-500/25"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-800 rounded-full font-medium text-sm hover:bg-background-200 transition-colors cursor-pointer border border-background-300"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门榜单
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-primary-500/10 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20and%20movie%20reel%20composition%20on%20warm%20dark%20background%2C%20artistic%20abstract%20cinema%20elements%20with%20soft%20golden%20light%20glow%2C%20elegant%20vintage%20movie%20theater%20aesthetic%2C%20film%20projector%20light%20beam%20effect%2C%20warm%20crimson%20and%20amber%20tones%2C%20dramatic%20cinematic%20atmosphere%2C%20high%20contrast%20lighting%2C%20sophisticated%20entertainment%20industry%20visual&width=800&height=600&seq=hero-cinema-main&orientation=landscape"
                alt="黄瓜影院 - 免费高清影视在线观看平台，电影大全海量片库"
                className="w-full h-full object-cover object-top"
              />
              {/* Subtle overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/15 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}